const termsConditions = [
  {
    id: 1,
    trems:
      "Welcome to spiolabs.com (“website”). Spio Labs boasts of a team of dreamy yet resolute entrepreneurs who are building the next generation of class leading tech stack in the niche areas of Enterprise Wireless Access Management, Critical Infrastructure security and Operational Continuity & Cyber Attack Recovery for OT & IoT systems.",
  },
  {
    id: 2,
    trems:
      "The following terms and conditions govern your use of the website, access to your account on the website, and the purchase and use of its products and services.",
  },
  {
    id: 3,
    trems:
      "By accessing and using the features and services provided on the website, through whatever device or platform you choose, you are deemed to have accepted these terms and conditions. Please read them carefully.",
  },
  {
    id: 4,
    header: "1.Use of The Website :",
    subcontent: [
      {
        trems:
          "By using the website you agree to be legally bound by these terms, which shall take effect immediately on your first use of the website. If you do not agree to be legally bound by all the following terms please do not access and/or use the website.",
      },
      {
        trems:
          "Spio Lab may change these terms at any time by posting changes online. Please review these terms regularly to ensure you are aware of any changes made by Spio Lab. Your continued use of the website after changes are posted means you agree to be legally bound by these terms as updated and/or amended.",
      },
    ],
  },
  {
    id: 5,
    header: "2.Registration on The Website :",
    subcontent: [
      {
        trems:
          "You may not copy, reproduce, republish, download, post, broadcast, transmit, make available to the public, or otherwise use the website content, product content, materials, and videos in any way except for your own personal, non-commercial use. You also agree not to adapt, alter or create a derivative work from any of the website’s content, product content, materials, and videos except for your own personal, non-commercial use. Any other use of the website content, product content, materials, and videos require the prior written permission of Spio Lab.",
      },
      {
        trems:
          "You may download and print extracts from the material and make copies of these for your own personal and non-commercial use only. You are not allowed to download or print the material, or extracts from it, in a systematic or regular manner or otherwise so as to create a database in electronic or paper form comprising all or part of the material appearing on the website.",
      },
    ],
  },
  {
    id: 6,
    header: "3.Registration on The Website :",
    subcontent: [
      {
        trems:
          "Some areas of the website may require registration for the following purposes:",
        subTrems: [
          {
            term: "Registration of interest for an upcoming features or programme.",
          },
          {
            term: "Registration for a free access.",
          },
          {
            term: "Creation of an account for you to access the content of the products that you have purchased from Spio Lab",
          },
        ],
      },
      {
        trems:
          "When you register on the website, you should ready our privacy policy, which also governs your use of our products and services.",
      },
      {
        trems:
          "By completing the registration form and by entering the details required, you will be deemed to have accepted these terms and conditions.",
      },
    ],
  },
];
export default termsConditions;
